import styled from '@emotion/styled';
import { Box, List, Typography } from '@mui/material';
import { colors } from 'theme/colors';

const StyledCard = styled(Box)`
  display: grid;
  grid-template-rows: min-content auto min-content;
  padding: 20px;
  background: #ffffff;
  border: 1px solid ${colors.blue100};
  box-shadow: 0 2px 4px rgba(194, 204, 243, 0.35), 0 2px 6px rgba(194, 204, 243, 0.3),
    0 4px 8px rgba(194, 204, 243, 0.2), 0 6px 10px rgba(194, 204, 243, 0.2);
  border-radius: 4px;
  height: 100%;
`;

const StyledBox = styled(Box)`
  display: grid;
  align-content: space-between;
  padding: 20px;
  margin: 20px 0;
  border-radius: 4px;
  border: 1px solid ${colors.blue100};
  //height: 400px;
`;

const StyledTitle = styled(Typography)`
  font-weight: bold;
  text-align: center;
`;
const StyledTypography = styled(Typography)`
  font-weight: 700;
  line-height: 30px;

  & span {
    font-weight: normal;
  }
`;

const StyledList = styled(List)`
  margin-left: 35px;

  & li {
    padding: 0;
  }
`;

export { StyledCard, StyledBox, StyledTitle, StyledTypography, StyledList };
